/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Анимация маршрутов</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="http://reactcommunity.org/react-transition-group/with-react-router"
          target="_blank"
          rel="noopener noreferrer"
        >
          RTG With React Router
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="http://maisano.github.io/react-router-transition/"
          target="_blank"
          rel="noopener noreferrer"
        >
          React Router Transition
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/chAJ61qxrz0" target="_blank" rel="noopener noreferrer">
          React Router v4 and animating transitions
        </a>
      </li>
    </ul>
  </section>
))
